// import {
//     THREE
// } from 'GT3DEngine-module';
// import GT3DBaseView from 'GT3DBaseView-module';
import GT3DBaseView from '@/libs/GT3DBaseView';
import * as TWEEN from 'es6-tween';

const Status = {
    None: 0,
    Load: 1,
    Prepare: 2,
    OpeningAnimation: 3,
    SceneTour: 4,
    Show3DViewAnimation: 5,
    Show3DView: 6,
    ShowProductDetail: 7,
};

const Action = Window.Action = {
    None: 0,
    MoveForward: 1,
    MoveBack: 2,
    MoveLeft: 3,
    MoveRight: 4,
    RotateLeft: 5,
    RotateRight: 6,
    RotateUp: 7,
    RotateDown: 8,
    ZoomIn: 9,
    ZoomOut: 10,
};

const Step = {
    None: 0,
    Scene: 1,
    SceneMaterials: 2,
    Colliders: 3,
    ShowcaseDatas: 4,
    ShowcaseTextures: 5,
};

export default class GT3DPavilion extends GT3DBaseView {

    constructor(options) {
        super(options)
        if (this.options.updateShowcaseInterval === undefined)
            this.options.updateShowcaseInterval = 200
        if (this.options.updateShowcaseDistance === undefined)
            this.options.updateShowcaseDistance = 250
        if (this.options.isForceHorizontal === undefined)
            this.options.isForceHorizontal = false
    }

    initParams() {
        super.initParams();

        this.lastTime = 0;
        this.sceneStatus = Status.None;
        this.cameraAction = Action.None;
        this.loadStep = Step.None;

        this.raycaster = new THREE.Raycaster();
        this.ndc = new THREE.Vector2();

        this.onDownPosition = new THREE.Vector2();
        this.onUpPosition = new THREE.Vector2();
        this.prevClientPosition = new THREE.Vector2();
        this.isLeftButtonPressed = false;

        // this.openingAnimationIsRunning = false;
        // this.openingAnimationHasPlayed = false;
        this.autoTourIsRunning = false;
        this.savedAutoTourRunning = false;
        this.autoTourPathIndex = undefined;
        this.tourMoveTween = null;
        this.tourRotateTween = null;

        this.tempPosition = new THREE.Vector3();
        // this.savedPosition = new THREE.Vector3();
        // this.savedRotation = new THREE.Vector3();

        this.colliders = [];
        this.showcaseGroup = null;
        this.showcasePlaneArray = [];
        this.showcaseList = [];

        // this._3dViewIsLoading = false;
        this._3dViewRenderTargetHasRendered = false;

        TWEEN.autoPlay(false);

        THREE.DefaultPlaceholderMaterial = new THREE.MeshBasicMaterial({
            // color: Math.random() * 0xffffffff
            color: 0x000000,
            wireframe: true
        });
    }

    initRenderer() {
        let canvas = document.createElement('canvas')
        let context = canvas.getContext('webgl2')
        const renderer = this.renderer = new THREE.WebGLRenderer({
            canvas: canvas,
            context: context,
            // alpha: this.options.alpha,
            antialias: this.options.antialias
        })
        renderer.setSize(this.options.width, this.options.height)
        renderer.setPixelRatio(this.options.pixelRatio)
        this.options.element.appendChild && this.options.element.appendChild(renderer.domElement)
    }

    initScene() {
        super.initScene();

        this.showcaseGroup = new THREE.Group();
        this.showcaseGroup.name = 'ShowcaseGroup';
        this.scene.add(this.showcaseGroup);

        this._3dViewScene = new THREE.Scene();
        this._3dViewScene.name = '3dViewScene';
        this._3dViewRenderTarget = new THREE.WebGLRenderTarget(this.options.width, this.options.height);
        // _3dViewRenderTarget.generateMipmaps = false;
        this._3dViewScene.background = this._3dViewRenderTarget.texture;
        this._3dViewGroup = new THREE.Group();
        this._3dViewScene.add(this._3dViewGroup);
    }

    initCamera() {
        super.initCamera()

        this.camera.position.set(1000, 1000, 1000)
        this.camera.lookAt(new THREE.Vector3(0, 0, 0))

        this._3dViewCamera = new THREE.PerspectiveCamera(50, this.options.width / this.options.height, 0.1, 10000);
        this._3dViewCamera.name = '3dViewCamera';
        this._3dViewCamera.position.set(100, 100, 100);
        this._3dViewCamera.lookAt(new THREE.Vector3(0, 0, 0));
        this._3dViewScene.add(this._3dViewCamera);

        let baseUrl = this.ensureBaseUrl();
        let url = baseUrl + '/editor/images/show3dview_bg.png';
        let map = new THREE.TextureLoader().load(url);
        let plane = this._3dViewBg = new THREE.Mesh(new THREE.PlaneBufferGeometry(1, 1), new THREE.MeshBasicMaterial({
            // color: 0x777777,
            transparent: true,
            // opacity: 0.8
            map: map
        }));
        plane.position.set(0, 0, -1000);
        plane.scale.set(2000, 2000, 2000);
        this._3dViewCamera.add(plane);
    }

    // initLoadingManager() {
    //     this.manager = new THREE.LoadingManager();
    //     this.manager.onStart = (url, itemsLoaded, itemsTotal) => {};
    //     this.manager.onLoad = () => {
    //         if (this.loadStep === Step.ShowcaseTextures) {
    //             console.log('Loading complete!');
    //             this._notifyLoadingComplete();
    //             if (this._checkNeedReadSceneStatus()) {
    //                 this.openingAnimationHasPlayed = true;
    //                 if (this._readSceneStatus()) {
    //                     if (this.options.onOpeningAnimaitionCompleted)
    //                         this.options.onOpeningAnimaitionCompleted(true);
    //                     return;
    //                 }
    //                 this.openingAnimationHasPlayed = false;
    //             }
    //             if (this.openingAnimationHasPlayed == false)
    //                 this._startOpeningAnimation();
    //             this.loadStep = Step.None;
    //         }
    //     };
    //     this.manager.onProgress = (url, itemsLoaded, itemsTotal) => {
    //         // console.log( 'Loading progress: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );
    //         switch (this.loadStep) {
    //             case Step.ShowcaseTextures:
    //                 let progress = itemsLoaded / itemsTotal;
    //                 this._notifyLoadingProgress(progress);
    //                 break;
    //         }
    //     };
    //     this.manager.onError = (url) => {
    //         // console.error( 'There was an error loading ' + url );
    //     };
    // }

    initControls() {
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseWheel = this.onMouseWheel.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this)

        this.options.element.addEventListener('mousedown', this.onMouseDown, false);
        this.options.element.addEventListener('wheel', this.onMouseWheel, false);
        this.options.element.addEventListener('mousemove', this.onMouseMove, false);
        this.options.element.addEventListener('mouseup', this.onMouseUp, false);
        this.options.element.addEventListener('mouseleave', this.onMouseUp, false);

        this.options.element.addEventListener('touchstart', this.onTouchStart, false);
        this.options.element.addEventListener('touchmove', this.onTouchMove, false);
        this.options.element.addEventListener('touchend', this.onTouchEnd, false);
        this.options.element.addEventListener('touchcancel', this.onTouchEnd, false);

        window.addEventListener("keydown", this.onKeyDown, false);
        window.addEventListener("keyup", this.onKeyUp, false);

        this._3dViewControls = new THREE.OrbitControls(this._3dViewCamera, this.renderer.domElement);
        this._3dViewControls.name = '3dViewControls';
        this._3dViewControls.screenSpacePanning = true;
        this._3dViewControls.isForceHorizontal = this.options.isForceHorizontal;
        this._3dViewControls.enabled = false;
    }

    disposeControls() {
        this.options.element.removeEventListener('mousedown', this.onMouseDown, false);
        this.options.element.removeEventListener('wheel', this.onMouseWheel, false);
        this.options.element.removeEventListener('mousemove', this.onMouseMove, false);
        this.options.element.removeEventListener('mouseup', this.onMouseUp, false);
        this.options.element.removeEventListener('mouseleave', this.onMouseUp, false);

        this.options.element.removeEventListener('touchstart', this.onTouchStart, false);
        this.options.element.removeEventListener('touchmove', this.onTouchMove, false);
        this.options.element.removeEventListener('touchend', this.onTouchEnd, false);
        this.options.element.removeEventListener('touchcancel', this.onTouchEnd, false);

        window.removeEventListener("keydown", this.onKeyDown, false);
        window.removeEventListener("keyup", this.onKeyUp, false);
    }

    onOrientationChange() {
        super.onOrientationChange();
        if (this.options.isForceHorizontal) {
            if (window.orientation === 0) {
                this.needUseHorizontal = true;
            } else {
                this.needUseHorizontal = false;
            }
        }
    }

    onResize() {
        let result = super.onResize();
        if (result) {
            this._3dViewCamera.aspect = this.options.width / this.options.height;
            this._3dViewCamera.updateProjectionMatrix();

            this._3dViewRenderTarget.setSize(this.options.width, this.options.height);
        }
        return result;
    }

    onMouseDown(event) {
        // event.preventDefault();
        // if (this.sceneStatus === Status.Prepare) {
        //     this._startOpeningAnimation();
        //     return;
        // }
        // if (this.sceneStatus !== Status.SceneTour)
        //     return;
        // console.log('onMouseDown: ', event);
        if (event.button === 0) {
            this.isLeftButtonPressed = true;
            this.onDownPosition.set(event.clientX, event.clientY);
            this.prevClientPosition.set(event.clientX, event.clientY);
        }
    }

    onMouseMove(event) {
        // event.preventDefault();
        // if (this.sceneStatus !== Status.SceneTour)
        //     return;
        if (this.isLeftButtonPressed) {
            // console.log('onMouseMove: ', event);
            let deltaX = event.clientX - this.prevClientPosition.x;
            let deltaY = event.clientY - this.prevClientPosition.y;
            // console.log('delta: ', deltaX, deltaY);
            let canAction = false;
            if (this.sceneStatus === Status.OpeningAnimation && this.sceneType === 2)
                canAction = true;
            else if (this.sceneStatus === Status.Prepare || this.sceneStatus === Status.SceneTour)
                canAction = true;
            // if (this.sceneStatus === Status.OpeningAnimation && this.cameraObject) {
            //     if (this.sceneType === 2) {
            //         if (Math.abs(deltaX) > Math.abs(deltaY)) {
            //             if (deltaX < 0) {
            //                 this.cameraObject.position.x -= 0.005;
            //             } else if (deltaX > 0) {
            //                 this.cameraObject.position.x += 0.005;
            //             }
            //         } else {
            //             if (deltaY < 0) {
            //                 this.cameraObject.position.y += 0.005;
            //                 if (this.cameraObject.position.y > 0.05)
            //                     this.cameraObject.position.y = 0.05;
            //             } else if (deltaY > 0) {
            //                 this.cameraObject.position.y -= 0.005;
            //                 if (this.cameraObject.position.y < -0.05)
            //                     this.cameraObject.position.y = -0.05;
            //             }
            //         }
            //     }
            // } else 
            if (canAction) {
                if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
                    if (Math.abs(deltaX) > Math.abs(deltaY)) {
                        if (deltaX < 0)
                            this.cameraAction = Action.RotateLeft;
                        else if (deltaX > 0)
                            this.cameraAction = Action.RotateRight;
                    } else {
                        if (deltaY < 0)
                            this.cameraAction = Action.RotateUp;
                        else if (deltaY > 0)
                            this.cameraAction = Action.RotateDown;
                    }
                } else {
                    if (Math.abs(deltaX) > Math.abs(deltaY)) {
                        if (deltaX < 0)
                            this.cameraAction = Action.RotateLeft;
                        else if (deltaX > 0)
                            this.cameraAction = Action.RotateRight;
                    }
                }
            }
            this.prevClientPosition.set(event.clientX, event.clientY);
        }
    }

    onMouseUp(event) {
        // event.preventDefault();
        // if (this.sceneStatus !== Status.SceneTour)
        //     return;
        // console.log('onMouseUp: ', event);
        this.onUpPosition.set(event.clientX, event.clientY);
        if (this.isLeftButtonPressed) {
            if (this.sceneStatus === Status.Prepare) {
                if (this.onDownPosition.equals(this.onUpPosition))
                    this._startOpeningAnimation();
            } else if (this.sceneStatus === Status.SceneTour) {
                this._checkTriggerEvent();
            }
        }
        // if (event.button === 0) {
        this.isLeftButtonPressed = false;
        // }
        this.cameraAction = Action.None;
    }

    onMouseWheel(event) {
        // event.preventDefault();
        if (this.sceneStatus !== Status.SceneTour)
            return;
        // console.log('onMouseWheel: ', event);
        if (event.deltaY < 0) {
            if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
                this._doCameraAction(Action.ZoomIn);
            } else {
                this._doCameraAction(Action.MoveForward);
            }
        } else if (event.deltaY > 0) {
            if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
                this._doCameraAction(Action.ZoomOut);
            } else {
                this._doCameraAction(Action.MoveBack);
            }
        }
    }

    onTouchStart(event) {
        // event.preventDefault();
        // if (this.sceneStatus === Status.Prepare) {
        //     this._startOpeningAnimation();
        //     return;
        // }
        // if (this.sceneStatus !== Status.SceneTour)
        //     return;
        // console.log('onTouchStart: ', event);
        let touch = null;
        if (event.touches && event.touches.length > 0) {
            touch = event.touches[0];
        } else if (event.changedTouches && event.changedTouches.length > 0) {
            touch = event.changedTouches[0];
        }
        if (touch) {
            this.isLeftButtonPressed = true;
            this.onDownPosition.set(touch.clientX, touch.clientY);
            this.prevClientPosition.set(touch.clientX, touch.clientY);
        }
    }

    onTouchMove(event) {
        // event.preventDefault();
        // if (this.sceneStatus !== Status.SceneTour)
        //     return;
        // console.log('onTouchMove: ', event);
        if (this.isLeftButtonPressed) {
            let touch = null;
            if (event.touches && event.touches.length > 0) {
                touch = event.touches[0];
            } else if (event.changedTouches && event.changedTouches.length > 0) {
                touch = event.changedTouches[0];
            }
            if (touch) {
                let deltaX = touch.clientX - this.prevClientPosition.x;
                let deltaY = touch.clientY - this.prevClientPosition.y;
                let canAction = false;
                if (this.sceneStatus === Status.OpeningAnimation && this.sceneType === 2)
                    canAction = true;
                else if (this.sceneStatus === Status.Prepare || this.sceneStatus === Status.SceneTour)
                    canAction = true;
                // console.log('delta: ', deltaX, deltaY);
                // if (this.sceneStatus === Status.OpeningAnimation) {
                //     if (this.sceneType === 2 && this.cameraObject) {
                //         if (Math.abs(deltaX) > Math.abs(deltaY)) {
                //             if (deltaX < 0) {
                //                 if (this.needUseHorizontal) {
                //                     this.cameraObject.position.y -= 0.005;
                //                     if (this.cameraObject.position.y < -0.05)
                //                         this.cameraObject.position.y = -0.05;
                //                 } else {
                //                     this.cameraObject.position.x -= 0.005;
                //                 }
                //             } else if (deltaX > 0) {
                //                 if (this.needUseHorizontal) {
                //                     this.cameraObject.position.y += 0.005;
                //                     if (this.cameraObject.position.y > 0.05)
                //                         this.cameraObject.position.y = 0.05;
                //                 } else {
                //                     this.cameraObject.position.x += 0.005;
                //                 }
                //             }
                //         } else {
                //             if (deltaY < 0) {
                //                 if (this.needUseHorizontal) {
                //                     this.cameraObject.position.x -= 0.005;
                //                 } else {
                //                     this.cameraObject.position.y += 0.005;
                //                     if (this.cameraObject.position.y > 0.05)
                //                         this.cameraObject.position.y = 0.05;
                //                 }
                //             } else if (deltaY > 0) {
                //                 if (this.needUseHorizontal) {
                //                     this.cameraObject.position.x += 0.005;
                //                 } else {
                //                     this.cameraObject.position.y -= 0.005;
                //                     if (this.cameraObject.position.y < -0.05)
                //                         this.cameraObject.position.y = -0.05;
                //                 }
                //             }
                //         }
                //     }
                // } else
                if (canAction) {
                    if (Math.abs(deltaX) > Math.abs(deltaY)) {
                        if (deltaX < 0)
                            // doCameraAction(Action.RotateLeft);
                            if (this.needUseHorizontal) {
                                if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
                                    this.cameraAction = Action.RotateDown;
                                } else {
                                    if (this.sceneStatus === Status.Prepare)
                                        this.cameraAction = Action.None;
                                    else
                                        this.cameraAction = Action.MoveBack;
                                }
                            } else {
                                this.cameraAction = Action.RotateLeft;
                            }
                        else if (deltaX > 0)
                            // doCameraAction(Action.RotateRight);
                            if (this.needUseHorizontal) {
                                if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
                                    this.cameraAction = Action.RotateUp;
                                } else {
                                    if (this.sceneStatus === Status.Prepare)
                                        this.cameraAction = Action.None;
                                    else
                                        this.cameraAction = Action.MoveForward;
                                }
                            } else {
                                this.cameraAction = Action.RotateRight;
                            }
                    } else {
                        if (deltaY < 0)
                            // doCameraAction(Action.MoveForward);
                            if (this.needUseHorizontal) {
                                this.cameraAction = Action.RotateLeft;
                            } else {
                                if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
                                    this.cameraAction = Action.RotateUp;
                                } else {
                                    if (this.sceneStatus === Status.Prepare)
                                        this.cameraAction = Action.None;
                                    else
                                        this.cameraAction = Action.MoveForward;
                                }
                            }
                        else if (deltaY > 0)
                            // doCameraAction(Action.MoveBack);
                            if (this.needUseHorizontal) {
                                this.cameraAction = Action.RotateRight;
                            } else {
                                if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
                                    this.cameraAction = Action.RotateDown;
                                } else {
                                    if (this.sceneStatus === Status.Prepare)
                                        this.cameraAction = Action.None;
                                    else
                                        this.cameraAction = Action.MoveBack;
                                }
                            }
                    }
                }
                // prevClientPosition.set(touch.clientX, touch.clientY);
            }
        }
    }

    onTouchEnd(event) {
        // event.preventDefault();
        // if (this.sceneStatus !== Status.SceneTour)
        //     return;
        // console.log('onTouchEnd: ', event);
        let touch = null;
        if (event.touches && event.touches.length > 0) {
            touch = event.touches[0];
        } else if (event.changedTouches && event.changedTouches.length > 0) {
            touch = event.changedTouches[0];
        }
        if (touch) {
            this.onUpPosition.set(touch.clientX, touch.clientY);
            if (this.isLeftButtonPressed) {
                if (this.sceneStatus === Status.Prepare) {
                    if (this.onDownPosition.equals(this.onUpPosition))
                        this._startOpeningAnimation();
                } else if (this.sceneStatus === Status.SceneTour) {
                    this._checkTriggerEvent();
                }
            }
        }
        this.isLeftButtonPressed = false;
        this.cameraAction = Action.None;
    }

    onKeyDown(event) {
        // event.preventDefault();
        if (this.sceneStatus === Status.Show3DView || this.sceneStatus === Status.ShowProductDetail)
            this.hide3DView();
        if (this.sceneStatus !== Status.SceneTour)
            return;
        switch (event.key.toLowerCase()) {
            case 'w':
            case 'arrowup':
                if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
                    this._doCameraAction(Action.RotateUp);
                } else {
                    this._doCameraAction(Action.MoveForward);
                }
                break;
            case 's':
            case 'arrowdown':
                if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
                    this._doCameraAction(Action.RotateDown);
                } else {
                    this._doCameraAction(Action.MoveBack);
                }
                break;
            case 'a':
            case 'arrowleft':
                if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
                    this._doCameraAction(Action.RotateLeft);
                } else {
                    this._doCameraAction(Action.MoveLeft);
                }
                break;
            case 'd':
            case 'arrowright':
                if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
                    this._doCameraAction(Action.RotateRight);
                } else {
                    this._doCameraAction(Action.MoveRight);
                }
                break;
            case 'e':
                this._stopAutoTour();
                break;
            case 'r':
                this._startAutoTour();
                break;
        }
    }

    onKeyUp(event) {
        // event.preventDefault();
        // if (this.sceneStatus !== Status.SceneTour)
        //     return;
    }

    onFrameUpdate() {
        TWEEN.update();
        if (this.sceneStatus !== Status.Show3DView && this.sceneStatus !== Status.ShowProductDetail) {
            this._updateCameraTransform();
            this._updateShowcaseDataList();
            this._updateFrameAnimationTextures();
            if (this.cameraAction !== Action.None)
                this._doCameraAction(this.cameraAction);
        }
    }

    render() {
        if (this.sceneStatus === Status.Show3DView) {
            if (!this._3dViewRenderTargetHasRendered) {
                this._3dViewRenderTargetHasRendered = true;
                this.renderer.setRenderTarget(this._3dViewRenderTarget);
                this.renderer.render(this.scene, this.camera);
                this.renderer.setRenderTarget(null);
                console.log('_3dViewRenderTarget render.');
            }
            this.renderer.render(this._3dViewScene, this._3dViewCamera);
        } else {
            this.renderer.render(this.scene, this.camera);
        }
    }

    /**
     * [setSceneData description]
     * @param {[type]} sceneData    [description]
     * @param {[type]} showcaseList [description]
     */
    setSceneData(sceneData, showcaseListData) {
        console.log('setSceneData: ', sceneData, showcaseListData)
        this.options.sceneData = sceneData
        this.options.showcaseListData = showcaseListData
    }

    /**
     * [set3DViewListener description]
     * @param  {[type]} onStart    [description]
     * @param  {[type]} onProgress [description]
     * @param  {[type]} onFinished [description]
     * @param  {[type]} onError    [description]
     * @return {[type]}            [description]
     */
    set3DViewListener(onStart, onProgress, onFinished, onError) {
        if (onStart)
            this.options.on3DViewLoadStart = onStart;
        if (onProgress)
            this.options.on3DViewLoadProgress = onProgress;
        if (onFinished)
            this.options.on3DViewLoadFinished = onFinished;
        if (onError)
            this.options.on3DViewLoadError = onError;
    }

    ensurePavilions(onLoad, onError) {
        return new Promise((resolve, reject) => {
            if (this.pavilions) {
                if (onLoad)
                    onLoad(this.pavilions);
                resolve(this.pavilions);
                return;
            }
            let baseUrl = this.ensureBaseUrl();
            let url = baseUrl + '/editor/pavilions/pavilions.json';
            // console.log('ensurePavilions: ', url);
            let loader = new THREE.FileLoader();
            loader.load(url, (text) => {
                this.pavilions = JSON.parse(text);
                console.log('ensurePavilions: ', this.pavilions);
                if (onLoad)
                    onLoad(this.pavilions);
                resolve(this.pavilions);
            }, undefined, (error) => {
                console.error('ensurePavilions error: ', error);
                if (onError)
                    onError(error);
                reject(error);
            });
        });
    }

    ensureObjectsUrl() {
        if (this.options.sceneData) {
            if (this.pavilions) {
                let list = this.pavilions.list;
                for (let i = list.length - 1; i >= 0; i--) {
                    if (this.options.sceneData.id === list[i].id)
                        return list[i].objects;
                }
            }
            if (this.options.sceneData.objects)
                return this.options.sceneData.objects;
            if (this.options.sceneData.scene) {
                let basePath = THREE.LoaderUtils.extractUrlBase(this.options.sceneData.scene);
                return basePath + 'objects.gtzip';
            }
        }
        return null;
    }

    ensureMaterialsUrl() {
        if (this.options.sceneData) {
            if (this.pavilions) {
                let list = this.pavilions.list;
                for (let i = list.length - 1; i >= 0; i--) {
                    if (this.options.sceneData.id === list[i].id)
                        return list[i].materials;
                }
            }
            if (this.options.sceneData.materials)
                return this.options.sceneData.materials;
            if (this.options.sceneData.scene) {
                let basePath = THREE.LoaderUtils.extractUrlBase(this.options.sceneData.scene);
                return basePath + 'materials.json';
            }
        }
        return null;
    }

    /**
     * [startLoadScene description]
     * @param  {[type]} onFinished [description]
     * @param  {[type]} onProgress [description]
     * @param  {[type]} onError    [description]
     * @return {[type]}            [description]
     */
    startLoadScene(onLoad, onProgress, onError) {
        if (onLoad)
            this.options.onLoad = onLoad;
        if (onProgress)
            this.options.onProgress = onProgress;
        if (onError)
            this.options.onError = onError;
        return new Promise((resolve, reject) => {
            this.sceneStatus = Status.Load;
            this.loadStep = Step.Scene;
            if (this.options.sceneData === undefined) {
                let error = 'the sceneData is undefined.';
                console.warn(error);
                if (onError)
                    onError(error);
                reject(error);
                return
            }
            this.ensurePavilions(() => {
                let baseUrl = this.ensureBaseUrl();
                let url = this.ensureObjectsUrl();
                if (!url.startsWith('http')) {
                    url = baseUrl + '/editor/pavilions' + url;
                }
                this.loadScene(url, (result) => {
                    this._notifyLoadingProgress(1);
                    if (this.options.sceneData.type)
                        this.sceneType = this.options.sceneData.type;
                    else
                        this.sceneType = 0;
                    if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
                        this._prepareSceneData(result.userData);
                    } else
                        this._initPaths(result.userData.paths);

                    this.loadStep = Step.SceneMaterials;
                    url = this.ensureMaterialsUrl();
                    if (!url.startsWith('http')) {
                        url = baseUrl + '/editor/pavilions' + url;
                    }
                    this.loadMaterialsToScene(url, () => {
                        if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
                            this._initShowcaseList(() => {
                                this._notifyLoadingProgress(1);
                                this._initShowcaseListTextures((noData) => {
                                    // if (noData) {
                                    this._notifyLoadingProgress(1);
                                    // this.manager.onLoad();
                                    this._onLoadingComplete();
                                    // }
                                    resolve();
                                });
                            }, (progress) => {
                                this._notifyLoadingProgress(progress);
                            });
                            return;
                        }
                        this._initColliders(result.userData.colliders, () => {
                            this._initTriggers(result.userData.triggers);
                            this._initFrameAnimationTextures(result.userData.frameAnimationTextures);
                            this._notifyLoadingProgress(1);
                            this._initShowcaseList(() => {
                                this._notifyLoadingProgress(1);
                                this._initShowcaseListTextures((noData) => {
                                    // if (noData) {
                                    this._notifyLoadingProgress(1);
                                    // this.manager.onLoad();
                                    this._onLoadingComplete();
                                    // }
                                    resolve();
                                }, (progress) => {
                                    this._notifyLoadingProgress(progress);
                                });
                            });
                        });
                    }, (progress) => {
                        this._notifyLoadingProgress(progress);
                    }, (error) => {
                        this._notifyLoadingError(xhr);
                        reject(error);
                    });
                }, (progress) => {
                    this._notifyLoadingProgress(progress);
                }, (error) => {
                    this._notifyLoadingError(error);
                    reject(error);
                })
            }, (error) => {
                this._notifyLoadingError(error);
                reject(error);
            });
        });
    }

    _prepareSceneData(data) {
        // console.log('prepareSceneData: ', data);
        this.initAnimations();
        this.scene.traverse((child) => {
            if (child.name === data.animationRoot)
                this.animationRoot = child;
            else if (child.name === data.cameraObject) {
                this.cameraObject = child;
                if (data.cameraTweenObject) {
                    for (let i = child.children.length - 1; i >= 0; i--) {
                        if (data.cameraTweenObject === child.children[i].name) {
                            this.cameraTweenObject = child.children[i];
                            break;
                        }
                    }
                }
            } else if (data.hideObjects) {
                this.hideObjects = [];
                for (let i = data.hideObjects.length - 1; i >= 0; i--) {
                    if (child.name === data.hideObjects[i]) {
                        this.hideObjects.push(child);
                    }
                }
            }
        });
        if (this.cameraTweenObject === undefined)
            this.cameraTweenObject = this.cameraObject;
        // console.log('cameraObject: ', this.cameraObject, "cameraTweenObject: ", this.cameraTweenObject);
        this.prepareAnimation = data.prepareAnimation;
        this.openingAnimation = data.openingAnimation;
        this.openingAnimationPaths = data.openingAnimationPaths;
        this.sceneAnimation = data.sceneAnimation;
        if (this.sceneType === 2 && this.cameraTweenObject) {
            let position = new THREE.Vector3();
            this.cameraTweenObject.getWorldPosition(position);
            this.camera.position.set(position.x, position.y, position.z + 0.3);
            this.camera.lookAt(position);
        }
    }

    _initPaths(data) {

        function convertDegArrayToRad(array) {
            for (let i = array.length - 1; i >= 0; i--) {
                array[i] = THREE.Math.degToRad(array[i]);
            }
            return array;
        }

        console.log('initPaths: ', data);
        this.openingAnimation = data.openingAnimation;
        for (let i = this.openingAnimation.rotations.length - 1; i >= 0; i--) {
            convertDegArrayToRad(this.openingAnimation.rotations[i]);
        }
        this.tourPaths = data.tourPaths;
        for (let i = this.tourPaths.rotations.length - 1; i >= 0; i--) {
            convertDegArrayToRad(this.tourPaths.rotations[i]);
        }

        this.camera.position.fromArray(this.openingAnimation.positions[0]);
        this.camera.rotation.fromArray(this.openingAnimation.rotations[0]);

    }

    _initColliders(data, onFinished) {
        return new Promise((resolve, reject) => {
            this.loadStep = Step.Colliders;
            let loader = new THREE.ObjectLoader(this.manager);
            loader.setCrossOrigin('*');
            let result = loader.parse(data);
            result.traverse((child) => {
                if (child.isMesh) {
                    let box = new THREE.Box3();
                    box.setFromObject(child);
                    // console.log(box);
                    this.colliders.push(box);
                }
            });
            result.dispose();
            if (onFinished)
                onFinished();
            resolve(result);
        });
    }

    _initTriggers(data) {
        if (data) {
            this.triggers = [];
            for (let i = data.length - 1; i >= 0; i--) {
                this.scene.traverseVisible((child) => {
                    if (child.name === data[i].name || child.uuid === data[i].uuid) {
                        child.triggerItem = data[i];
                        this.triggers.push(child);
                    }
                });
            }
            console.log('initTriggers: ', this.triggers);
        }
    }

    _initFrameAnimationTextures(data) {
        if (data) {
            this.frameAnimationTextures = [];
            for (let i = data.length - 1; i >= 0; i--) {
                this.scene.traverseVisible((child) => {
                    if (child.material) {
                        if (Array.isArray(child.material)) {
                            for (let j = child.material.length - 1; j >= 0; j--) {
                                if (child.material[j].uuid === data[i].uuid) {
                                    data[i].material = child.material[j];
                                    this.frameAnimationTextures.push(data[i]);
                                }
                            }
                        } else {
                            if (child.material.uuid === data[i].uuid) {
                                data[i].material = child.material;
                                this.frameAnimationTextures.push(data[i]);
                            }
                        }
                    }
                });
            }
            console.log('initFrameAnimationTextures:', this.frameAnimationTextures);
        }
    }

    _initShowcaseList(onFinished) {
        return new Promise((resolve, reject) => {
            this.loadStep = Step.ShowcaseDatas;
            if (this.options.showcaseListData === undefined) {
                console.warn('the showcaseListData is undefined.');
                if (onFinished)
                    onFinished();
                reject();
                return;
            }
            let showcaseListData = this.options.showcaseListData;
            let material, plane;
            let geometry = new THREE.PlaneBufferGeometry(1, 1);
            for (let i = 0; i < showcaseListData.length; i++) {
                let item = showcaseListData[i];
                material = new THREE.MeshBasicMaterial({
                    transparent: true,
                });
                plane = new THREE.Mesh(geometry, material);
                if (item.parent) {
                    let matrix = new THREE.Matrix4();
                    matrix.fromArray(item.matrix);
                    matrix.decompose(plane.position, plane.quaternion, plane.scale);
                    this.scene.traverse((child) => {
                        if (child.name === item.parent)
                            child.add(plane);
                    });
                } else {
                    let matrixWorld = new THREE.Matrix4();
                    matrixWorld.fromArray(item.matrixWorld);
                    matrixWorld.decompose(plane.position, plane.quaternion, plane.scale);
                    this.showcaseGroup.add(plane);
                }
                this.showcasePlaneArray.push(plane);
                item.plane = plane;
                this.showcaseList.push(item);
                plane.item = item;
            }
            if (onFinished)
                onFinished();
            resolve();
        });
    }

    _initShowcaseListTextures(onFinished, onProgress) {
        this.loadStep = Step.ShowcaseTextures;
        let texloader = new THREE.TextureLoader(this.manager);
        let i = 0,
            length = this.showcaseList.length;

        function readTextures(imageArray, num) {
            let textureArray = [];
            for (let i = 0; i < num; i++) {
                let url = imageArray[i];
                if (url) {
                    if (url.startsWith('http://img2.tutubox.cn')) {
                        url = url.replace('http://img2.tutubox.cn', 'https://img2.tutubox.cn');
                    } else if (url.startsWith('http://img.tutubox.cn')) {
                        url = url.replace('http://img.tutubox.cn', 'https://img.tutubox.cn');
                    }
                    let texture = texloader.load(url);
                    texture.generateMipmaps = false;
                    texture.minFilter = THREE.LinearFilter;
                    textureArray.push(texture);
                }
            }
            // console.log('readTextures: ', textureArray);
            return textureArray;
        }

        let loadNextShowcase = () => {
            if (this.isDestroyed)
                return;
            if (onProgress)
                onProgress(i / length);
            if (i < length) {
                let item = this.showcaseList[i];
                if (item.preview360 && item.preview360.length > 0) {
                    let textures = readTextures(item.preview360, Math.min(1, item.preview360.length));
                    item.plane.textures = textures;
                    item.plane.texIdx = 0;
                    item.plane.material.map = textures[0];
                } else {
                    item.plane.visible = false;
                }
                i++;
                loadNextShowcase();
            } else {
                if (onFinished)
                    onFinished();
            }
        };

        loadNextShowcase();
    }

    _onLoadingComplete() {
        console.log('Loading complete!');
        this._notifyLoadingComplete();
        if (this._checkNeedReadSceneStatus()) {
            // this.openingAnimationHasPlayed = true;
            this.sceneStatus = Status.SceneTour;
            if (this._readSceneStatus()) {
                if (this.options.onOpeningAnimaitionCompleted)
                    this.options.onOpeningAnimaitionCompleted(true);
                return;
            }
            // this.openingAnimationHasPlayed = false;
        }
        // if (this.openingAnimationHasPlayed == false)
        //     this._startOpeningAnimation();
        this.sceneStatus = Status.Prepare;
        this.loadStep = Step.None;
        if (this.prepareAnimation) {
            this.playAnimation(this.prepareAnimation);
        }
    }

    _startOpeningAnimation() {
        if (this.stopAnimationFrameFlag)
            return;
        // this.openingAnimationIsRunning = true;
        // setTimeout(() => {
        console.log('startOpeningAnimation...', this.sceneType);
        this.sceneStatus = Status.OpeningAnimation;
        if (this.sceneType === 2) { //2:白熊展馆
            if (this.sceneAnimation) {
                if (Array.isArray(this.sceneAnimation)) {
                    for (let i = this.sceneAnimation.length - 1; i >= 0; i--) {
                        this.playAnimation(this.sceneAnimation[i], {
                            loop: THREE.LoopRepeat
                        });
                    }
                } else {
                    this.playAnimation(this.sceneAnimation, {
                        loop: THREE.LoopRepeat
                    });
                }
            }
            let prepareAction = this.getAnimationAction(this.prepareAnimation);
            let openingAction = this.getAnimationAction(this.openingAnimation);
            prepareAction.paused = true;
            // openingAction.paused = true;
            // openingAction.enabled = true;
            openingAction.loop = THREE.LoopRepeat;
            openingAction.setEffectiveTimeScale(1);
            openingAction.setEffectiveWeight(1);
            // openingAction.time = 0;
            openingAction.play();

            let length = this.openingAnimationPaths.positions.length;
            let totalDistance = Math.abs(this.openingAnimationPaths.positions[length - 1][2] - this.openingAnimationPaths.positions[0][2]);
            let totalDuration = this.openingAnimationPaths.totalDuration;

            let nextStep = (index) => {
                if (this.stopAnimationFrameFlag)
                    return;
                // console.log('openingAnimation nextStep: ', index);
                if (index >= length) {
                    // console.log('OpeningAnimation Finished');
                    // this.sceneStatus = Status.SceneTour;
                    this.cameraObject = null;
                    // this.openingAnimationIsRunning = false;
                    // this.openingAnimationHasPlayed = true;
                    // this.autoTourIsRunning = true;
                    // if (this.options.onOpeningAnimaitionCompleted)
                    //     this.options.onOpeningAnimaitionCompleted();
                    let array = this.openingAnimationPaths.lastPaths.cameraObject.position;
                    let tweenMove = new TWEEN.Tween(this.cameraTweenObject.position);
                    tweenMove.to({
                        x: array[0],
                        y: array[1],
                        z: array[2]
                    }, this.openingAnimationPaths.lastPaths.cameraObject.duration);
                    tweenMove.start();

                    array = this.openingAnimationPaths.lastPaths.camera.position;
                    tweenMove = new TWEEN.Tween(this.camera.position);
                    tweenMove.to({
                        x: array[0],
                        y: array[1],
                        z: array[2]
                    }, this.openingAnimationPaths.lastPaths.camera.duration);
                    tweenMove.on('complete', () => {
                        this.sceneStatus = Status.SceneTour;
                        this.cameraObject = null;
                        // this.openingAnimationIsRunning = false;
                        // this.openingAnimationHasPlayed = true;
                        this.autoTourIsRunning = true;
                        if (this.options.onOpeningAnimaitionCompleted)
                            this.options.onOpeningAnimaitionCompleted();
                    });
                    tweenMove.start();

                    array = this.openingAnimationPaths.lastPaths.camera.rotation;
                    if (array) {
                        let tweenRotate = new TWEEN.Tween(this.camera.rotation);
                        tweenRotate.to({
                            x: THREE.Math.degToRad(array[0]),
                            y: THREE.Math.degToRad(array[1]),
                            z: THREE.Math.degToRad(array[2])
                        }, this.openingAnimationPaths.lastPaths.camera.duration);
                        tweenRotate.start();
                    }
                } else {
                    let duration = 1000;
                    if (index > 0) {
                        let distance = Math.abs(this.openingAnimationPaths.positions[index][2] - this.openingAnimationPaths.positions[index - 1][2]);
                        duration = distance * totalDuration / totalDistance;
                    }
                    let array = this.openingAnimationPaths.positions[index];
                    let tweenMove = new TWEEN.Tween(this.cameraTweenObject.position);
                    tweenMove.to({
                        x: array[0],
                        y: array[1],
                        z: array[2]
                    }, duration);
                    tweenMove.on('complete', () => {
                        nextStep(index + 1);
                    });
                    tweenMove.start();

                    tweenMove = new TWEEN.Tween(this.camera.position);
                    let scale = this.cameraObject.scale;
                    tweenMove.to({
                        x: array[0] * scale.x,
                        y: array[1] * scale.y,
                        z: array[2] * scale.z + 0.3
                    }, duration);
                    tweenMove.start();

                    array = this.openingAnimationPaths.rotations[index];
                    if (array) {
                        let tweenRotate = new TWEEN.Tween(this.cameraTweenObject.rotation);
                        tweenRotate.to({
                            x: THREE.Math.degToRad(array[0]),
                            y: THREE.Math.degToRad(array[1]),
                            z: THREE.Math.degToRad(array[2])
                        }, duration);
                        tweenRotate.start();
                    }
                }
            };
            nextStep(0);
            // if (this.cameraChild) {
            //     let tweenRotate = new TWEEN.Tween(this.cameraChild.rotation);
            //     tweenRotate.to({
            //         x: THREE.Math.degToRad(-90),
            //         y: 0,
            //         z: 0
            //     }, 1000);
            //     // tweenRotate.on('complete', () => {
            //     // console.log('tweenRotate complete.');
            //     // this.sceneStatus = Status.OpeningAnimation;
            //     // });
            //     tweenRotate.start();
            // }
            // if (this.cameraObject) {
            //     let tweenMove = new TWEEN.Tween(this.cameraObject.position);
            //     tweenMove.to({
            //         z: -3.5
            //     }, 10000);
            //     tweenMove.on('complete', () => {
            //         console.log('tweenMove complete.');
            //         let center = this.computeObjectCenter(this.cameraObject);
            //         let tweenMove = new TWEEN.Tween(this.cameraObject.position);
            //         this.cameraObject = null;
            //         tweenMove.to({
            //             // x: 10,
            //             y: 2,
            //             z: -7
            //         }, 10000);
            //         tweenMove.start();
            //         tweenMove = new TWEEN.Tween(this.camera.position);
            //         tweenMove.to({
            //             x: 7.645,
            //             y: 0.1,
            //             z: 0.75
            //         }, 2000);
            //         tweenMove.start();
            //         let tweenRotate = new TWEEN.Tween(this.camera.rotation);
            //         tweenRotate.to({
            //             x: 0,
            //             y: 0,
            //             z: 0
            //         }, 2000);
            //         tweenRotate.on('complete', () => {
            //             console.log('tweenRotate complete.', this.camera);
            //             this.sceneStatus = Status.SceneTour;
            //             this.cameraObject = null;
            //             // this.openingAnimationIsRunning = false;
            //             // this.openingAnimationHasPlayed = true;
            //             this.autoTourIsRunning = true;
            //             if (this.options.onOpeningAnimaitionCompleted)
            //                 this.options.onOpeningAnimaitionCompleted();
            //         });
            //         tweenRotate.start();
            //         // this.sceneStatus = Status.OpeningAnimation;
            //     });
            //     tweenMove.start();
            // }
            return;
        } else if (this.sceneType === 3) { //3:奇趣太空
            // this.sceneStatus = Status.OpeningAnimation;

            let finished = () => {
                this.sceneStatus = Status.SceneTour;
                this.cameraObject = null;
                // this.openingAnimationIsRunning = false;
                // this.openingAnimationHasPlayed = true;
                this.autoTourIsRunning = true;
                if (this.options.onOpeningAnimaitionCompleted)
                    this.options.onOpeningAnimaitionCompleted();
            };
            if (this.sceneAnimation) {
                if (Array.isArray(this.sceneAnimation)) {
                    for (let i = this.sceneAnimation.length - 1; i >= 0; i--) {
                        this.playAnimation(this.sceneAnimation[i], {
                            loop: THREE.LoopRepeat
                        });
                    }
                } else {
                    this.playAnimation(this.sceneAnimation, {
                        loop: THREE.LoopRepeat
                    });
                }
            }
            if (this.openingAnimation)
                this.playAnimation(this.openingAnimation, {
                    loop: THREE.LoopOnce,
                    clampWhenFinished: true,
                }, finished);
            else
                finished();
            return;
        }

        // this.sceneStatus = Status.OpeningAnimation;

        let nextStep = (index) => {
            if (this.stopAnimationFrameFlag)
                return;
            // console.log('openingAnimation nextStep: ', index);
            if (index >= this.openingAnimation.positions.length) {
                console.log('OpeningAnimation Finished');
                this.sceneStatus = Status.SceneTour;
                this.cameraObject = null;
                // this.openingAnimationIsRunning = false;
                // this.openingAnimationHasPlayed = true;
                this.autoTourIsRunning = true;
                this._startAutoTour(1);
                if (this.options.onOpeningAnimaitionCompleted)
                    this.options.onOpeningAnimaitionCompleted();
            } else {
                let array = this.openingAnimation.positions[index];
                let tweenMove = new TWEEN.Tween(this.camera.position);
                tweenMove.to({
                    x: array[0],
                    y: array[1],
                    z: array[2]
                }, this.openingAnimation.durations[index]);
                tweenMove.on('complete', () => {
                    nextStep(index + 1);
                });
                array = this.openingAnimation.rotations[index];
                this._ensureCameraYRotation(array[1]);
                let tweenRotate = new TWEEN.Tween(this.camera.rotation);
                tweenRotate.to({
                    x: array[0],
                    y: array[1],
                    z: array[2]
                }, this.openingAnimation.durations[index]);
                tweenMove.start();
                tweenRotate.start();
            }
        };

        nextStep(1);
    }

    _setAutoTourPaused(paused) {
        this.autoTourIsRunning = !paused;
        if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
            if (this.sceneAnimation) {
                if (Array.isArray(this.sceneAnimation)) {
                    for (var i = this.sceneAnimation.length - 1; i >= 0; i--) {
                        let action = this.getAnimationAction(this.sceneAnimation[i]);
                        action.paused = paused;
                    }
                } else {
                    let action = this.getAnimationAction(this.sceneAnimation);
                    action.paused = paused;
                }
            }
        } else {
            if (paused) {
                if (this.tourMoveTween)
                    this.tourMoveTween.pause();
                if (this.tourRotateTween)
                    this.tourRotateTween.pause();
            } else {
                if (this.tourMoveTween)
                    this.tourMoveTween.play();
                if (this.tourRotateTween)
                    this.tourRotateTween.play();
            }
        }
    }

    _stopAutoTour() {
        if (this.sceneStatus !== Status.SceneTour)
            return;
        console.log('stopAutoTour');
        this.autoTourIsRunning = false;
        if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
            if (Array.isArray(this.sceneAnimation)) {
                for (var i = this.sceneAnimation.length - 1; i >= 0; i--) {
                    this.pauseAnimation(this.sceneAnimation[i]);
                }
            } else {
                this.pauseAnimation(this.sceneAnimation);
            }
            return;
        }
        if (this.tourMoveTween) {
            this.tourMoveTween.pause();
            this.tourMoveTween.stop();
            TWEEN.remove(this.tourMoveTween);
            this.tourMoveTween = null;
        }
        if (this.tourRotateTween) {
            this.tourRotateTween.pause();
            this.tourRotateTween.stop();
            TWEEN.remove(this.tourRotateTween);
            this.tourRotateTween = null;
        }
    }

    _startAutoTour(index) {
        if (this.sceneStatus !== Status.SceneTour || this.stopAnimationFrameFlag)
            return;

        if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
            this.autoTourIsRunning = true;
            if (Array.isArray(this.sceneAnimation)) {
                for (var i = this.sceneAnimation.length - 1; i >= 0; i--) {
                    this.resumeAnimation(this.sceneAnimation[i]);
                }
            } else {
                this.resumeAnimation(this.sceneAnimation);
            }
            return;
        }

        let prevTourPathIdx = (index) => {
            index--;
            if (index < 0)
                index = this.tourPaths.positions.length - 1;
            return index;
        }

        let nextTourPathIdx = (index) => {
            index++;
            if (index > this.tourPaths.positions.length - 1)
                index = 0;
            return index;
        }

        let nextStep = (index) => {
            if (this.stopAnimationFrameFlag)
                return;
            this.autoTourIsRunning = true;
            let nextIndex = nextTourPathIdx(index);
            this.autoTourPathIndex = nextIndex;
            let array = this.tourPaths.positions[nextIndex];
            this.tempPosition.fromArray(array);
            let distance = this.tempPosition.distanceTo(this.camera.position);
            let duration = distance / this.tourPaths.speed;
            // console.log('autoTour nextStep: ', nextIndex, distance, duration);
            this.tourMoveTween = new TWEEN.Tween(this.camera.position);
            this.tourMoveTween.to({
                x: array[0],
                y: array[1],
                z: array[2]
            }, duration).on('complete', () => {
                this.tourMoveTween = null;
                if (this.autoTourIsRunning === false)
                    return;
                nextStep(nextIndex);
            }).start();
            array = this.tourPaths.rotations[nextIndex];
            this._ensureCameraYRotation(array[1]);
            // if (Math.abs(this.camera.rotation.y - array[1]) > Math.PI) {
            //     console.log('rotation offset > PI', this.camera.rotation.y, array[1]);
            //     let rad360 = THREE.Math.degToRad(360);
            //     if (array[1] > 0) {
            //         this.camera.rotation.y = (this.camera.rotation.y + rad360) % rad360;
            //     } else {
            //         this.camera.rotation.y = (this.camera.rotation.y - rad360) % rad360;
            //     }
            // }
            this.tourRotateTween = new TWEEN.Tween(this.camera.rotation);
            this.tourRotateTween.to({
                // x: array[0],
                y: array[1],
                // z: array[2]
            }, this.tourPaths.duration).on('complete', () => {
                // console.log(camera.rotation);
                this.tourRotateTween = null;
            }).start();
        };

        console.log('startAutoTour: ', index);
        this.autoTourIsRunning = true;
        if (index) {
            nextStep(index - 1);
            return;
        }
        let nearestDistance = Number.MAX_VALUE;
        let nearestIndex = -1;
        for (let i = 0; i < this.tourPaths.positions.length; i++) {
            let array = this.tourPaths.positions[i];
            this.tempPosition.fromArray(array);
            let distance = this.tempPosition.distanceTo(this.camera.position);
            if (distance > 0 && distance < nearestDistance) {
                nearestDistance = distance;
                nearestIndex = i;
            }
        }
        nextStep(nearestIndex - 1);
        return;
    }

    _ensureCameraYRotation(yTarget) {
        if (Math.abs(this.camera.rotation.y - yTarget) > Math.PI) {
            // console.log('camera y rotation offset > PI', this.camera.rotation.y, yTarget);
            let rad360 = THREE.Math.degToRad(360);
            if (yTarget > 0) {
                this.camera.rotation.y = (this.camera.rotation.y + rad360) % rad360;
            } else {
                this.camera.rotation.y = (this.camera.rotation.y - rad360) % rad360;
            }
        }
    }

    _updateCameraTransform() {
        if (this.cameraObject) {
            // if (this.sceneType === 2) { //白熊展馆
            //     if (this.sceneStatus === Status.OpeningAnimation) {
            //         let position = new THREE.Vector3();
            //         this.cameraTweenObject.getWorldPosition(position);
            //         // let center = this.computeObjectCenter(this.cameraObject);
            //         // console.log('center: ', center);
            //         // this.camera.position.set(center.x, center.y, center.z + 0.5);
            //         this.camera.position.set(position.x, position.y, position.z + 0.3);
            //         this.camera.lookAt(position);
            //     }
            // } else 
            if (this.sceneType === 3) { //奇趣太空
                this.cameraObject.getWorldPosition(this.camera.position);
                this.cameraObject.getWorldQuaternion(this.camera.quaternion);
                this.camera.rotateX(THREE.Math.degToRad(90));
                this.camera.updateMatrixWorld();
            }
        }
    }

    _updateShowcaseDataList() {
        if (!this.showcasePlaneArray || this.showcasePlaneArray.length === 0)
            return;
        let time = new Date().getTime();
        if (time - this.lastTime >= this.options.updateShowcaseInterval) {
            // console.log('updateShowcaseList: ', time);
            for (let i = this.showcaseList.length - 1; i >= 0; i--) {
                let item = this.showcaseList[i];
                let child = item.plane;
                if (child.visible) {
                    child.lookAt(this.camera.position);
                    if (child.textures && child.textures.length > 1) {
                        child.visible = true;
                        let length = child.textures.length;
                        child.texIdx++;
                        if (child.texIdx >= length)
                            child.texIdx = 0;
                        child.material.map = child.textures[child.texIdx];
                        // child.material.uniforms.map.value = child.textures[child.texIdx];
                        child.material.needsUpdate = true;
                    }
                }
            }
            this.lastTime = time;
        }
    }

    _updateFrameAnimationTextures() {
        if (!this.frameAnimationTextures || this.frameAnimationTextures.length === 0)
            return;
        let time = new Date().getTime();
        let texloader = new THREE.TextureLoader();
        for (let i = this.frameAnimationTextures.length - 1; i >= 0; i--) {
            let data = this.frameAnimationTextures[i];
            if (data.material === undefined || data.images === undefined || data.images.length === 0)
                continue;
            if (data.interval === undefined)
                data.interval = 1000;
            if (data.time === undefined || time - data.time >= data.interval) {
                data.time = time;
                if (data.index === undefined)
                    data.index = -1;
                let index = data.index;
                index++;
                if (index >= data.images.length)
                    index = 0;
                data.index = index;
                if (data.textures === undefined) {
                    data.textures = [];
                } else if (data.images.length === 1) {
                    continue;
                }
                if (data.textures[index] === undefined) {
                    let url = data.images[index];
                    texloader.load(url, (texture) => {
                        texture.generateMipmaps = false;
                        texture.minFilter = THREE.LinearFilter;
                        data.textures[index] = texture;
                        // if (data.type === undefined)
                        //     data.type = 'map';
                        // switch (data.type) {
                        //     case 'envMap':
                        //         break;
                        //     default:
                        data.material.map = texture;
                        data.material.needsUpdate = true;
                        // break;
                        // }
                    });
                } else {
                    let texture = data.textures[index];
                    data.material.map = texture;
                    data.material.needsUpdate = true;
                }
            }
        }
    }

    _doCameraAction(action) {

        let checkIsCollided = () => {
            if (this.colliders.length === 0)
                return false;
            if (this.cameraSphere === undefined) {
                this.cameraSphere = new THREE.Sphere(new THREE.Vector3(), 1);
            }
            this.cameraSphere.center.copy(this.camera.position);
            for (let i = this.colliders.length - 1; i >= 0; i--) {
                if (this.cameraSphere.intersectsBox(this.colliders[i]))
                    return true;
            }
            return false;
        }

        switch (action) {
            case Action.MoveForward:
                if (this.autoTourIsRunning)
                    return;
                this.camera.translateZ(-1);
                if (checkIsCollided())
                    this.camera.translateZ(1);
                break;
            case Action.MoveBack:
                if (this.autoTourIsRunning)
                    return;
                this.camera.translateZ(1);
                if (checkIsCollided())
                    this.camera.translateZ(-1);
                break;
            case Action.MoveLeft:
                if (this.autoTourIsRunning)
                    return;
                this.camera.translateX(-1);
                if (checkIsCollided())
                    this.camera.translateX(1);
                break;
            case Action.MoveRight:
                if (this.autoTourIsRunning)
                    return;
                this.camera.translateX(1);
                if (checkIsCollided())
                    this.camera.translateX(-1);
                break;
            case Action.RotateLeft:
                this.camera.rotation.y += THREE.Math.degToRad(1);
                if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
                    if (this.camera.rotation.y > THREE.Math.degToRad(30))
                        this.camera.rotation.y = THREE.Math.degToRad(30);
                }
                break;
            case Action.RotateRight:
                this.camera.rotation.y += THREE.Math.degToRad(-1);
                if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
                    if (this.camera.rotation.y < THREE.Math.degToRad(-30))
                        this.camera.rotation.y = THREE.Math.degToRad(-30);
                }
                break;
            case Action.RotateUp:
                this.camera.rotation.x += THREE.Math.degToRad(1);
                if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
                    if (this.camera.rotation.x > THREE.Math.degToRad(10))
                        this.camera.rotation.x = THREE.Math.degToRad(10);
                }
                break;
            case Action.RotateDown:
                this.camera.rotation.x += THREE.Math.degToRad(-1);
                if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
                    if (this.camera.rotation.x < THREE.Math.degToRad(-10))
                        this.camera.rotation.x = THREE.Math.degToRad(-10);
                }
                break;
            case Action.ZoomIn:
                this.camera.zoom *= 1.1;
                if (this.camera.zoom > 2)
                    this.camera.zoom = 2;
                this.camera.updateProjectionMatrix();
                break;
            case Action.ZoomOut:
                this.camera.zoom /= 1.1;
                if (this.camera.zoom < 0.5)
                    this.camera.zoom = 0.5;
                this.camera.updateProjectionMatrix();
                break;
        }
    }

    _checkTriggerEvent() {

        let getNDC = (point) => {

            let rect = this.options.element.getBoundingClientRect();
            // console.log('rect: ', rect, 'point: ', point);
            let x = (point.x - rect.left) / rect.width;
            let y = (point.y - rect.top) / rect.height;
            if (this.needUseHorizontal) {
                let y2 = 1 - x;
                let x2 = y;
                x = x2;
                y = y2;
            }
            // console.log('x:', x, 'y:', y);
            this.ndc.set((x * 2) - 1, -(y * 2) + 1);
            // console.log('ndc: ', this.ndc);

            return this.ndc;

        }

        let getIntersects = (point, objects) => {

            this.raycaster.setFromCamera(getNDC(point), this.camera);

            return this.raycaster.intersectObjects(objects);

        }

        if (this.onDownPosition.equals(this.onUpPosition)) {
            let intersects = getIntersects(this.onUpPosition, this.showcasePlaneArray);
            if (intersects.length > 0) {
                let object = intersects[0].object;
                this._saveSceneStatus();
                window.sessionStorage.setItem("needReadSceneStatus", "true");
                console.log('onTrigger3DView: ', object.item);
                // if (this.options.onTrigger3DView)
                //     this.options.onTrigger3DView(object.item);
                this.show3DView(object.item, object);
            } else {
                intersects = getIntersects(this.onUpPosition, this.triggers);
                if (intersects.length > 0) {
                    let object = intersects[0].object;
                    console.log('onTrigger: ', object.triggerItem);
                    this.show3DView(object.triggerItem, object);
                }
            }
        }
    }

    computeCrossAngle(from, to) {
        // console.log("computeCrossAngle");
        let cross = new THREE.Vector3();
        cross.crossVectors(from, to);
        // console.log('cross: ', cross);
        let angle;
        if (cross.y < 0) {
            angle = -from.angleTo(to);
        } else {
            angle = from.angleTo(to);
        }
        // console.log("angle: " + angle);
        return angle;
    }

    load3DViewModel(modelPath, onFinished) {
        return new Promise((resolve, reject) => {
            if (modelPath) {
                let url = this.options.baseUrl + '/models/' + modelPath + '.gt3d';
                // let url = 'http://t.p.gemtec.ltd' + '/models/' + modelPath + '.gt3d';

                console.log('load3DViewModel: ', url);
                this.loadScene(url, () => {
                    if (onFinished)
                        onFinished();
                    resolve();
                }, (progress) => {
                    if (this.options.on3DViewLoadProgress)
                        this.options.on3DViewLoadProgress(progress);
                }, (error) => {
                    if (this.options.on3DViewLoadError)
                        this.options.on3DViewLoadError(error);
                    reject(error);
                }, this._3dViewGroup, this._3dViewCamera, this._3dViewControls);
            }
        });
    }

    show3DView(item, object) {
        if (this.sceneStatus === Status.Show3DViewAnimation || this.sceneStatus === Status.Show3DView || this.sceneStatus === Status.ShowProductDetail)
            return;

        // let load3DViewModelImpl = () => {
        //     if (item.modelId && item.modelId.length > 0) {
        //         if (this.options.on3DViewLoadStart)
        //             this.options.on3DViewLoadStart(item);
        //         this.load3DViewModel(item.modelId).then(() => {
        //             if (this.options.on3DViewLoadFinished)
        //                 this.options.on3DViewLoadFinished();
        //         });
        //     }
        // };

        let show3DViewImpl = () => {
            if (this.options.onShowcaseClicked)
                this.options.onShowcaseClicked(item);
            this.savedAutoTourRunning = this.autoTourIsRunning;
            this._setAutoTourPaused(true);
            if (item.modelId && item.modelId.length > 0) {
                this._3dViewGroup.scale.set(0.001, 0.001, 0.001);
                this._3dViewGroup.rotation.set(0, 0, 0);
                this._3dViewBg.material.opacity = 0;
                // this._3dViewBg.material.needsUpdate = true;
                // this._3dViewBg.scale.set(0.001, 0.001, 0.001);                
                // tweenScale = new TWEEN.Tween(this._3dViewBg.scale);
                // tweenScale.to({
                //     x: 2000,
                //     y: 2000,
                //     z: 2000
                // }, 2000);
                // tweenScale.start();
                this.sceneStatus = Status.Show3DView;
                if (this.options.on3DViewLoadStart)
                    this.options.on3DViewLoadStart(item);
                this._3dViewRenderTargetHasRendered = false;
                // scene.disposeFromGPU();
                this._3dViewControls.enabled = true;
                // this.gemChecker = new GemChecker('http://t.tutubox.cn', this.renderer);
                this.load3DViewModel(item.modelId).then(() => {
                    if (this.options.on3DViewLoadFinished)
                        this.options.on3DViewLoadFinished();
                    let tweenOpacity = new TWEEN.Tween(this._3dViewBg.material);
                    tweenOpacity.to({
                        opacity: 1,
                    }, 2000);
                    tweenOpacity.start();
                    let tweenScale = new TWEEN.Tween(this._3dViewGroup.scale);
                    tweenScale.to({
                        x: 1,
                        y: 1,
                        z: 1
                    }, 2000);
                    tweenScale.start();
                    let tweenRotate = new TWEEN.Tween(this._3dViewGroup.rotation);
                    tweenRotate.to({
                        y: THREE.Math.degToRad(360)
                    }, 2000);
                    tweenRotate.start();
                });
            } else {
                this.sceneStatus = Status.ShowProductDetail;
            }
        };

        // load3DViewModelImpl();
        if (item.plane) {
            this.sceneStatus = Status.Show3DViewAnimation;
            this._setAutoTourPaused(true);
            this.savedCameraPosition = this.camera.position.clone();
            this.savedCameraRotation = this.camera.rotation.clone();
            // console.log('savedCamera: ', this.savedCameraPosition, this.savedCameraRotation);
            let worldPosition = new THREE.Vector3();
            item.plane.getWorldPosition(worldPosition);
            let position = worldPosition.clone();
            let direction = new THREE.Vector3();
            direction.subVectors(this.savedCameraPosition, position).normalize();
            let needMove = false;
            let rotation;
            if (this.sceneType === 2 || this.sceneType === 3) {
                this.camera.lookAt(position);
                this.camera.updateMatrixWorld();
                rotation = this.camera.rotation.clone();
                this.camera.rotation.copy(this.savedCameraRotation);
                position.add(direction.multiplyScalar(0.2));
                if (this.camera.position.distanceTo(worldPosition) > 0.2)
                    needMove = true;
            } else {
                let dir = direction.clone().negate();
                dir.y = 0;
                let angle = this.computeCrossAngle(new THREE.Vector3(0, 0, -1), dir);
                rotation = new THREE.Euler(0, angle, 0);
                position.add(direction.multiplyScalar(5));
                if (this.camera.position.distanceTo(worldPosition) > 5)
                    needMove = true;
            }
            // console.log('camera target: ', position, rotation);
            if (needMove) {
                let tweenMove = new TWEEN.Tween(this.camera.position);
                tweenMove.to({
                    x: position.x,
                    y: position.y,
                    z: position.z
                }, 2000);
                tweenMove.start();
            }
            this._ensureCameraYRotation(rotation.y);
            let tweenRotate = new TWEEN.Tween(this.camera.rotation);
            tweenRotate.to({
                x: rotation.x,
                y: rotation.y,
                z: rotation.z
            }, 2000);
            tweenRotate.on('complete', () => {
                show3DViewImpl();
            });
            tweenRotate.start();
        } else {
            show3DViewImpl();
        }
    }

    hide3DView() {
        console.log('hide3DView: ', this.sceneStatus);
        if (this.sceneStatus !== Status.Show3DView && this.sceneStatus !== Status.ShowProductDetail)
            return;

        let hide3DViewImpl = () => {
            this.savedCameraPosition = null;
            this.savedCameraRotation = null;
            setTimeout(() => {
                this._setAutoTourPaused(!this.savedAutoTourRunning);
                // scope.startAnimationFrame();

                this.sceneStatus = Status.SceneTour;
            }, 500);
        };

        this.sceneStatus = Status.Show3DViewAnimation;
        this._3dViewControls.enabled = false;
        while (this._3dViewGroup.children.length > 0) {
            let child = this._3dViewGroup.children.pop();
            // if (child === this._3dViewCamera)
            //     continue;
            child.dispose();
        }
        // this._3dViewScene.add(this._3dViewCamera);
        if (this.savedCameraPosition && this.savedCameraRotation) {
            let tweenMove = new TWEEN.Tween(this.camera.position);
            tweenMove.to({
                x: this.savedCameraPosition.x,
                y: this.savedCameraPosition.y,
                z: this.savedCameraPosition.z
            }, 2000);
            tweenMove.on('complete', () => {
                hide3DViewImpl();
            });
            tweenMove.start();
            this._ensureCameraYRotation(this.savedCameraRotation.y);
            let tweenRotate = new TWEEN.Tween(this.camera.rotation);
            tweenRotate.to({
                x: this.savedCameraRotation.x,
                y: this.savedCameraRotation.y,
                z: this.savedCameraRotation.z
            }, 2000);
            tweenRotate.start();
        } else {
            hide3DViewImpl();
        }
    }

    _notifyLoadingProgress(progress) {
        switch (this.loadStep) {
            case Step.Scene:
                progress = progress * 0.3;
                break;
            case Step.SceneMaterials:
                progress = 0.3 + progress * 0.3;
                break;
            case Step.Colliders:
                progress = 0.6 + progress * 0.05;
                break;
            case Step.ShowcaseDatas:
                progress = 0.65 + progress * 0.05;
                break;
            case Step.ShowcaseTextures:
                progress = 0.7 + progress * 0.3;
                break;
        }
        console.log('notifyLoadingProgress: ', progress, this.loadStep);
        if (this.options.onProgress)
            this.options.onProgress(progress);
    }

    _notifyLoadingError(error) {
        if (this.options.onError)
            this.options.onError(error);
    }

    _notifyLoadingComplete() {
        if (this.options.onLoad)
            this.options.onLoad();
    }

    _saveSceneStatus() {
        let position = this.camera.position.clone();
        let rotation = this.camera.rotation.toVector3();
        let data = {
            position: position.toArray(),
            rotation: rotation.toArray(),
            autoTour: this.autoTourIsRunning,
            autoTourPathIndex: this.autoTourPathIndex
        };
        let value = JSON.stringify(data);
        console.log("saveSceneStatus: ", value);
        window.localStorage.setItem("sceneStatus", value);
    }

    _readSceneStatus() {
        let value = window.localStorage.getItem("sceneStatus");
        if (value === undefined || value === null || value === '')
            return false;
        let data = JSON.parse(value);
        console.log('readSceneStatus: ', data);
        this.camera.position.fromArray(data.position);
        this.camera.rotation.fromArray(data.rotation);
        if (data.autoTour) {
            this._startAutoTour(data.autoTourPathIndex);
        } else {
            this._stopAutoTour();
        }
        window.sessionStorage.setItem("needReadSceneStatus", "false");
        return true;
    }

    _checkNeedReadSceneStatus() {
        if (this.sceneType === 2 || this.sceneType === 3) { //2:白熊展馆,3:奇趣太空
            return false;
        }
        let value = window.sessionStorage.getItem("needReadSceneStatus");
        console.log('checkNeedReadSceneStatus: ', value);
        if (value === "true") {
            // window.sessionStorage.setItem("needReadSceneStatus", "false");
            return true;
        } else
            return false;
    }

    //隐藏天花板
    hideCeiling() {
        this.scene.traverse((child) => {
            if (child.type === 'Group' && child.name === '天花板')
                child.visible = false;
        });
    }

    //显示天花板
    showCeiling() {
        this.scene.traverse((child) => {
            if (child.type === 'Group' && child.name === '天花板')
                child.visible = true;
        });
    }

    //隐藏墙壁
    hideWall() {
        this.scene.traverse((child) => {
            if (child.type === 'Group' && child.name === '墙')
                child.visible = false;
        });
    }

    //显示墙壁
    showWall() {
        this.scene.traverse((child) => {
            if (child.type === 'Group' && child.name === '墙')
                child.visible = true;
        });
    }

    //是否自动游览模式
    isAutoTour() {
        return this.autoTourIsRunning;
    };

    //设置自动游览模式
    setAutoTour(auto) {
        if (auto) {
            this._startAutoTour();
        } else {
            this._stopAutoTour();
        }
    };

    //控制动作
    changeControlAction(action) {
        console.log('changeControlAction: ', action, this.sceneStatus);
        if (this.sceneStatus !== Status.SceneTour)
            return;
        this.cameraAction = action;
    };

    //是否有场景访问记录
    needReloadScene() {
        return this._checkNeedReadSceneStatus();
    };

    //保存当前场景状态
    saveScene() {
        console.log('saveScene');
        this._saveSceneStatus();
        window.sessionStorage.setItem("needReadSceneStatus", "true");
    };

    dispose() {

        this._stopAutoTour();
        TWEEN.removeAll();
        this.disposeControls();
        super.dispose();
        this.showcaseGroup = null;
        this.showcasePlaneArray = null;
        this.showcaseList = null;
        this.colliders = null;
        this.showcaseList = null;
        this.raycaster = null;
        this.ndc = null;
        this.onDownPosition = null;
        this.onUpPosition = null;
        this.prevClientPosition = null;
        this.tempPosition = null;
        // this.savedPosition = null;
        // this.savedRotation = null;
        if (this.gemChecker) {
            this.gemChecker.dispose();
            this.gemChecker = null;
        }
        if (this._3dViewScene) {
            this._3dViewScene.dispose();
            this._3dViewScene = null;
        }
        if (this._3dViewCamera) {
            this._3dViewCamera.dispose();
            this._3dViewCamera = null;
        }
        if (this._3dViewControls) {
            this._3dViewControls.dispose();
            this._3dViewControls = null;
        }
        if (this._3dViewRenderTarget) {
            this._3dViewRenderTarget.dispose();
            this._3dViewRenderTarget = null;
        }

    }
}

// let pavilion = new GT3DPavilion({
//     element: document.getElementById('gt3d-content'),
//     baseUrl: 'http://t.p.gemtec.ltd',
// });
// let url = 'http://t.p.gemtec.ltd/pavilion/hall/detail?id=5cda8b08422689685307b815'; //山河集 5cce9c4a42268947907254c6 大白熊 5cda8b08422689685307b815
// let loader = new THREE.FileLoader();
// loader.load(url, (text) => {
//     let res = JSON.parse(text);
//     console.log(res);
//     pavilion.setSceneData(res.data.arrange, res.data.gems);
//     pavilion.startLoadScene();
// });
// pavilion.setSceneData({
//     "id": 9,
//     "type": 2,
//     "name": "大白熊",
//     "objects": "/10/objects.gtzip",
//     "materials": "/10/materials.json",
//     "showcases": "/10/showcases.json"
// }, []);
// pavilion.startLoadScene();